export default "__VITE_ASSET__DcE31kCl__"